// --- SaniQ ---
import * as SurveysConstants from '../constants';

const initialState = {
  collection: [],
  isFetching: false,
  sorting: {
    sort: 'asc',
    order: 'name',
    query: ''
  },
  pagination: {
    total: 0,
    perPage: 10,
    totalPages: 0,
    page: 0
  }
};

export function systemSurveys(state = initialState, action) {
  switch (action.type) {
    case SurveysConstants.SYSTEM_SURVEYS_FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case SurveysConstants.SYSTEM_SURVEYS_FETCH_COMPLETED:
      return Object.assign({}, state, {
        collection: action.surveys,
        pagination: action.pagination,
        sorting: action.sorting,
        isFetching: false
      });
    default:
      return state;
  }
}
